import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";
import { ApplicationState } from "../../store";
import { IProfile, IProfileCategory } from "../../store/repIQPresetProfile/types";

interface IProps {
    updateSelectedPresetProfile: any;
    isSmallVersion: boolean;
    resetProfile: number;
}

const PresetProfile: React.FunctionComponent<IProps> = (props) => {
    const isPresetProfileLoading = useSelector((state: ApplicationState) => {
        return state.repIQPresetProfileState?.isLoading;
    });
    const presetProfiles: IProfileCategory[] = useSelector((state: ApplicationState) => {
        return state.repIQPresetProfileState?.presetProfileData;
    })!;
    const [isProfileSelected, setIsProfileSelected] = useState(false);
    const [selectedProfileName, setSelectedProfileName] = useState("");
    const [selectedProfileVal, setSelectedProfileVal] = useState("");

    const blankProfile = {
        profileName: "",
        profileID: -1,
        profileCategoryID: -1,
        profileCategoryName: "",
        categories: {
            Agreeableness: { high: 0, low: 0 },
            Conscientiousness: { high: 0, low: 0 },
            Extraversion: { high: 0, low: 0 },
            EmotionalRange: { high: 0, low: 0 },
            OpennessToExperiences: { high: 0, low: 0 },
        },
    };

    const resetProfile = () => {
        props.updateSelectedPresetProfile(blankProfile);
        setIsProfileSelected(false);
        setSelectedProfileName("");
        setSelectedProfileVal("");
    };

    const presetProfileChange = (e: any) => {
        let val = e.target.value;

        if (presetProfiles && presetProfiles.length > 0 && val && val !== "") {
            let selectedProfile: IProfile[] = [];

            presetProfiles.forEach((category: IProfileCategory) => {
                let filteredProfile = category.profiles.filter((profile) => profile.profileID === val);
                if (selectedProfile && selectedProfile.length === 0 && filteredProfile && filteredProfile.length > 0) {
                    selectedProfile = filteredProfile;
                    props.updateSelectedPresetProfile(selectedProfile[0]);
                    setIsProfileSelected(true);
                    setSelectedProfileName(category.profileCategoryName + ": " + selectedProfile[0].profileName);
                    setSelectedProfileVal(selectedProfile[0].profileID + "");
                }
            });
        } else {
            resetProfile();
        }
    };

    useEffect(() => {
        resetProfile();
    }, [props.resetProfile]);

    return (
        <React.Fragment>
            {isPresetProfileLoading ? (
                <div className="box loading"></div>
            ) : (
                <div className="personality-switcher margin-vertical-m">
                    <div className="row">
                        {props.isSmallVersion === false ? (
                            <div className="col-xs-12 col-no-gutter col-md-12">
                                <div className="row middle-sm">
                                    <div className="col-xs-12 col-sm-6 ">
                                        <div className="form-row row inline no-margin">
                                            <div className="col-xs-12 col-sm-4 col-no-gutter form-label">
                                                <label id="label-preset-profile">Preset Profile</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-8 col-no-gutter form-input">
                                                <select
                                                    className="inputbox"
                                                    aria-labelledby="label-preset-profile"
                                                    value={selectedProfileVal}
                                                    onChange={presetProfileChange}
                                                >
                                                    <option value="">Select a profile (Optional)</option>

                                                    {presetProfiles.map((profile: IProfileCategory, key) => (
                                                        <optgroup label={profile.profileCategoryName} key={key}>
                                                            {profile.profiles.map((prf: IProfile, index: number) => (
                                                                <option value={prf.profileID} key={index}>
                                                                    {prf.profileName}
                                                                </option>
                                                            ))}
                                                        </optgroup>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-xs-12 col-sm-6">
                                        <div className="small_text" id="benchmark-text-default" style={{ display: isProfileSelected ? "none" : "block" }}>
                                            Select a Preset Profile to view how your online personality scores compared to benchmarks in your selected field.
                                            <span className="tooltip-container" tabIndex={0}>
                                                <RenderIcons iconName="info-circle" />
                                                <span className="tooltip-text">Benchmarks describe average trait ranges for the selected field.</span>
                                            </span>
                                        </div>
                                        <div className="small_text" id="benchmark-text" style={{ display: isProfileSelected ? "block" : "none" }}>
                                            The personality benchmarks below are based on the optimum personality traits associated with a{" "}
                                            <strong>
                                                <span id="benchmark-profile-value">{selectedProfileName}</span>
                                            </strong>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="col-xs-12 col-no-gutter col-md-10 col-md-offset-1">
                                <div className="form-row row inline no-margin">
                                    <div className="col-xs-12 col-sm-4 col-no-gutter form-label">
                                        <label id="label-preset-profile">Preset Profile</label>
                                    </div>
                                    <div className="col-xs-12 col-sm-8 col-no-gutter form-input">
                                        <select
                                            className="inputbox"
                                            aria-labelledby="label-preset-profile"
                                            value={selectedProfileVal}
                                            onChange={presetProfileChange}
                                        >
                                            <option value="">Select a profile (Optional)</option>

                                            {presetProfiles.map((profile: IProfileCategory, key) => (
                                                <optgroup label={profile.profileCategoryName} key={key}>
                                                    {profile.profiles.map((prf: IProfile, index: number) => (
                                                        <option key={index} value={prf.profileID}>
                                                            {prf.profileName}
                                                        </option>
                                                    ))}
                                                </optgroup>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                                <div className="line-divider margin-vertical-s"></div>

                                <div className="small_text" id="benchmark-text-default" style={{ display: isProfileSelected ? "none" : "block" }}>
                                    Select a Preset Profile to view how your online personality scores compared to benchmarks in your selected field.
                                    <span className="tooltip-container" tabIndex={0}>
                                        <RenderIcons iconName="info-circle" />
                                        <span className="tooltip-text">Benchmarks describe average trait ranges for the selected field.</span>
                                    </span>
                                </div>
                                <div className="small_text" id="benchmark-text" style={{ display: isProfileSelected ? "block" : "none" }}>
                                    The personality benchmarks below are based on the optimum personality traits associated with a{" "}
                                    <strong>
                                        <span id="benchmark-profile-value">{selectedProfileName}</span>
                                    </strong>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default PresetProfile;
